import {Button, Card} from "antd"
import React from "react"
import {Survey} from "./Survey"
import {CloseOutlined, ArrowLeftOutlined} from "@ant-design/icons"
import {Link} from "react-router-dom"
import LeaveSurveyModal from "./LeaveSurveyModal"
import SurveyCardContent from "./SurveyCardContent"

export class SurveyCards extends Survey {
  getDefaultState () {
    return {
      current: 0,
      open: false,
      direction: '',
      prevIndex: null
    }
  }
  scrollToActiveStep = () => {
    const activeCardElement = document.querySelector(".survey-card.active")
    const isBigQuestion = this.state.bigQuestions.includes(this.state.current)

    if (activeCardElement) {
      setTimeout(() => {
        activeCardElement.scrollIntoView({
          behavior: "smooth",
          block: isBigQuestion ? "start" : "center",
        });
      }, 600)

    }

    if (isBigQuestion) {
      setTimeout(() => {
        window.scrollBy({ behavior: "smooth", top: -80 });
      }, 900);
    }

  }

  nextCard = async () => {
    const prevIndex = this.state.current

    await this.updateState({
      direction: "next",
      prevIndex: prevIndex
    })

    await this.nextStep()

    setTimeout(() => {
      this.updateState({direction: '', prevIndex: null})
    }, 500);
  }

  prevCard = async () => {
    const prevIndex = this.state.current

    await this.updateState({
      direction: "prev",
      prevIndex: prevIndex
    })

    await this.prevStep()

    setTimeout(() => {
      this.updateState({direction: '', prevIndex: null})
    }, 500)
  }

  getCardClassName = (index) => {
    const isActive = index === this.state.current;
    const isPrevious = index === this.state.prevIndex && this.state.direction;
    const direction = this.state.direction || '';

    if (isActive) return `survey-card active ${direction}`.trim();
    if (isPrevious) return `survey-card inactive ${direction}`.trim();
    return 'survey-card inactive';
  }

  getItems = () => {
    return []
  }

  render() {
    const items = this.getItems({
      gender: this.props.gender,
      questions: this.state.questions,
      setSurveyAnswer: this.setSurveyAnswer,
      type: this.props.type
    })

    return (
      <>
        {items.map((item, index) => (
          <Card
            key={index}
            className={this.getCardClassName(index)}
          >
            <CloseOutlined
              onClick={() => this.updateState({open: true})}
            />

            {index === 0 &&
              <SurveyCardContent
                headerText={item.header}
                questionText={item.title}
                description={item.description}
                backButton={<Link to="/" className="ant-btn ant-btn-link ant-btn-back"><ArrowLeftOutlined /> Zpět do portálu</Link>}
                nextButton={<Button className="btn btn-secondary btn-step" onClick={this.nextCard}>Přejít na dotazník</Button>}/>
            }

            {index > 0 &&
              <SurveyCardContent
                headerText={`Otázka č. ${index}`}
                questionText={item.title}
                description={item.description}
                backButton={<Button type="link" onClick={this.prevCard} icon={<ArrowLeftOutlined/>}>Předchozí otázka</Button>}
                nextButton={index < items.length - 1 ? (
                  <Button className="btn btn-secondary btn-step" onClick={this.nextCard}>Další otázka</Button>
                ) : (
                  this.props.submitButton
                )}
                questionCounter={<span>Počet otázek {index} / {items.length - 1}</span>}/>
            }


          </Card>
        ))}

      <LeaveSurveyModal open={this.state.open} onClose={() => this.updateState({open: false})}/>
      </>
    )
  }
}